import {ApiTags, baseApi} from "../../../app/api/baseApi";
import {CmQueryResult} from "../../../app/types";
import {ImpressionsResponseData} from "../types";


export const impressionsApiSlice = baseApi.injectEndpoints({
    endpoints: builder => ({
        getImpressions: builder.query<ImpressionsResponseData, string>({
            query: (params) => {
                return {
                    reducerPath: 'impressions',
                    url: `/api/v1/impressions?${params}`,
                    method: 'GET',
                }
            },
            providesTags: (_) => [ApiTags.EmissionsList],
        }),
        getImpressionsXlsx: builder.query<any, string>({
            query: (params) => {
                return {
                    reducerPath: 'xlsx_impressions',
                    url: `/api/v1/impressions?${params}&format=xlsx`,
                    method: 'GET',
                    responseHandler: async (response) => {
                        const url = URL.createObjectURL(await response.blob());
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'impressions');
                        document.body.appendChild(link);
                        link.click();
                    },
                    cache: "no-cache",
                }
            },
            providesTags: (_) => [ApiTags.EmissionsList],
            keepUnusedDataFor: 5
        }),
    })
})

export const {
    useGetImpressionsQuery,
    useLazyGetImpressionsXlsxQuery,
} = impressionsApiSlice